<!-- src/components/common/SectionHeader.vue -->
<template>
	<h4 class="mb-2 mt-1 font-medium text-gray-700">
		{{ title }}
		<slot name="badge"></slot>
	</h4>
</template>

<script setup lang="ts">
	defineProps<{
		title: string;
	}>();
</script>
